import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { FetchVulnerabilitiesResponse } from '../../../../shared/organizationPackages/response';

const fetchPackageVulnerabilities = (locator: string, version: string) => get<FetchVulnerabilitiesResponse>(
  `/api/packages/${nuc(locator)}/versions/${encodeURIComponent(version)}/vulnerabilities`,
  true,
);

export const getPackageVulnerabilitiesQueryKey = (locator: string, version: string) => [
  'packages',
  locator,
  'versions',
  version,
  'vulnerabilities',
];

export default function usePackageVulnerabilities(locator: string, version: string) {
  return useQuery<FetchVulnerabilitiesResponse>({
    queryKey: getPackageVulnerabilitiesQueryKey(locator, version),
    queryFn: () => fetchPackageVulnerabilities(locator, version),
    enabled: Boolean(locator && version),
    staleTime: 1000 * 60 * 5,
  });
}
